"use strict";

define('controller/board/detail',['require','exports','module','backbone','underscore','marionette','controller/base','model/board','moment','config','appkit/changes.helper','appkit/loader.helper','templates','libs/route.helper','libs/format/empty','langs','uikit/uikit','view/table.ellipsis'],function (require, exports, module) {
  var Backbone = require('backbone');
  var _ = require('underscore');
  var Mn = require('marionette');
  var RegionController = require('controller/base');
  var BoardModel = require('model/board');
  var moment = require('moment');
  var config = require('config');
  var ChangesHelper = require('appkit/changes.helper');
  var LoaderHelper = require('appkit/loader.helper');
  var Templates = require('templates');
  var RouteHelper = require('libs/route.helper');
  var emptyFormatter = require('libs/format/empty');
  var langs = require('langs');
  var UIKit = require('uikit/uikit');
  var TableEllipsis = require('view/table.ellipsis');
  function setupTableEllipsisOptions() {
    return {
      collection: new Backbone.Collection([{
        text: 'View More',
        icon: 'eye',
        action: 'edit'
      }, {
        text: 'Remove',
        icon: 'remove',
        action: 'remove'
      }]),
      childBindings: {
        text: 'text',
        icon: 'icon'
      },
      ariaLabel: 'manage member'
    };
  }
  var emptyFormat = emptyFormatter('--');
  var MEMBER_COLUMNS = [{
    text: 'Manage',
    useAccessibilityText: true,
    childView: TableEllipsis,
    collapsing: true,
    childViewOptions: setupTableEllipsisOptions
  }, {
    text: 'Name',
    data: 'person.boldHtmlDisplayName'
  }, {
    text: 'Membership',
    data: 'membership',
    formatter: emptyFormat
  }, {
    text: 'Status',
    data: 'scientificStatus',
    formatter: emptyFormat
  }, {
    text: 'Representation',
    data: 'representation',
    formatter: emptyFormat
  }, {
    text: 'Affiliation',
    data: 'affiliation',
    formatter: emptyFormat
  }, {
    text: 'Office',
    data: 'office',
    formatter: emptyFormat
  }];
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['board.detail'],
    useInjector: true,
    options: {
      sectionTitle: langs.phrase('Settings.ReviewBoards.Details.Title')
    }
  });
  var BoardDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_IRB_ADMIN'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new RootView(),
        board = new BoardModel({
          id: state.get('boardId')
        }),
        changesHelper = new ChangesHelper().add(board),
        unsavedModalEvents = app.request('modal', {
          type: 'UNSAVED_CHANGES',
          state: changesHelper
        }, {
          ariaControlsId: 'boardDetails'
        }),
        calendar = new UIKit.Calendar({
          selectable: true,
          aligned: 'center'
        }),
        datePopup = new UIKit.Popup({
          showOn: 'click',
          width: UIKit.Popup.WIDE,
          position: 'bottom left',
          content: calendar,
          compact: true,
          borderless: true
        }),
        members = board.members(),
        memberHistory = board.membersByDate(),
        form = root.form,
        manualTrigger = false,
        resources = [],
        table = root.table;
      calendar.$el.css('width', '300px');
      app.execute('setupDimmer', root.dimmer, new LoaderHelper([members, memberHistory], {
        delay: 0
      }));
      var COLUMNS = MEMBER_COLUMNS.slice(0);
      COLUMNS[0] = _.clone(COLUMNS[0]);
      COLUMNS[0].onBeforeAdd = function (view, model) {
        var currentRowView = this;
        view.on('action', function (child, action) {
          rowActionPress(model, action, currentRowView);
        });
      };
      function showMemberDetail(member) {
        app.request('build:boardMemberDetail', {
          model: member,
          parent: root
        }).on('hidden', function () {
          members.fetch();
        });
      }
      ;
      function showAddMemberView() {
        var personFinderOverlay = app.request('personFinderOverlay', {
          ignore: members.pluck('person')
        });
        personFinderOverlay.on('save', function (personnel) {
          return Promise.map(personnel, function (p) {
            return board.createMember(p).save();
          }, {
            concurrency: 1
          }).tap(function () {
            if (!_.isEmpty(personnel)) {
              return members.fetch();
            }
          })["finally"](app.request('dimmer'));
        });
      }
      ;
      function rowActionPress(member, action, rowView) {
        switch (action.get('action')) {
          case 'edit':
            showMemberDetail(member);
            break;
          case 'remove':
            app.request('modal', {
              type: 'CONFIRM_DESTROY',
              state: state,
              entity: 'Board Member',
              name: member.get('personDisplayName'),
              action: 'Remove'
            }, {
              ariaControlsId: rowView.cid
            }).on('confirm', function () {
              member.destroy({
                wait: true
              }).promise().then(function (d) {
                members.fetch();
                return d;
              });
            });
            break;
        }
      }
      ;
      form.addGroup({
        autoSize: false
      }).addField({
        width: 14,
        text: 'Name'
      }, new UIKit.Input({
        name: 'title'
      })).getOption('parent').addField({
        width: 2,
        text: 'Active'
      }, new UIKit.Checkbox({
        toggle: true,
        polar: true,
        name: 'active'
      })).getOption('parent').getOption('parent').addField({
        text: 'Description'
      }, new UIKit.Input({
        name: 'description',
        multiLine: true
      }));
      root.$el.css(config.contentCss);
      table.$el.css('border', '0');
      form.model = board;
      form.bindings.title = 'name';
      form.bindings.active = 'active';
      form.bindings.description = 'description';
      table.ariaLabel = 'review board roster';
      table.columns.set(COLUMNS);
      table.collection = members;
      table.striped = false;
      table.sortable = false;
      table.selection = 'single';
      table.selectable = true;
      table.tabletStackable = true;
      table.$el.css({
        'margin-bottom': '0px'
      });
      root.saveButton.model = new LoaderHelper([board], {
        delay: 0
      });
      root.saveButton.bindings.loading = 'loading';
      root.saveButton.disabled = true;
      root.addMemberButton.disabled = board.isNew();
      root.breadcrumb.collection = new Backbone.Collection([{
        text: 'Review Boards',
        link: RouteHelper.createLink('board:list')
      }, {
        text: langs.phrase('Settings.ReviewBoards.Details.Title')
      }]);
      calendar.controls.fluid = true;
      calendar.controls.text.disabled = true;
      calendar.value = moment(new Date());
      root.dateButton.text = calendar.value.format('L');
      root.dateButton.disabled = true;
      datePopup.attach(root.dateButton);
      changesHelper.listenTo(root, 'destroy', changesHelper.off);
      root.on('saveButton:press', function () {
        board.save();
      }).on('addMemberButton:press', function () {
        showAddMemberView();
      }).listenTo(table, 'row:double:press', function (row) {
        if (table.selectable) {
          showMemberDetail(row.model);
        }
      }).listenTo(root.todayButton, 'press', function () {
        calendar.value = moment(new Date());
      }).listenTo(calendar, 'change:value', function () {
        var m = calendar.value,
          today = new Date();
        if (m.isSame(today, 'day') || m.isAfter(today, 'day')) {
          table.collection = members;
          table.selection = 'single';
          table.selectable = true;
          root.dateButton.color = 'white';
          root.todayButton.visible = false;
          root.addMemberButton.disabled = false;
        } else {
          m = m.clone().endOf('day');
          memberHistory.params({
            date: +m
          }).fetch();
          table.selection = null;
          table.selectable = false;
          table.collection = memberHistory;
          root.todayButton.visible = true;
          root.addMemberButton.disabled = true;
        }
        root.dateButton.text = calendar.value.format('L');
      });
      root.listenTo(unsavedModalEvents, 'save:model', function () {
        board.save();
      }).listenTo(board, 'sync', function () {
        changesHelper.reset();
        root.addMemberButton.disabled = false;
        root.dateButton.disabled = false;
      }).listenTo(members, 'sync', function () {
        table._renderChildren();
      }).listenTo(changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        root.saveButton.disabled = !changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      });
      if (board.isNew()) {
        root.once('show', _.debounce(function () {
          form.title.focus();
        }, 100)).listenTo(board, 'sync', function () {
          members.params({
            id: board.id
          }).fetch();
          state.changeRouteName('board:detail').set({
            boardId: board.id
          });
        });
      } else {
        board.fetch();
        members.fetch();
        resources = [board, members];
      }
      state.addPageDependencies(resources).on('page:loaded', function () {
        region.show(root);
      }).on('page:error', function () {
        app.navigate(RouteHelper.createLink('board:list').slice(1), {
          trigger: true
        });
        root.destroy();
      }).on('page:cancel', function () {
        root.destroy();
      });
    }
  });
  module.exports = BoardDetailController;
});

